import { kea } from 'kea'
import { put } from 'redux-saga/effects'
import PropTypes from 'prop-types'

import updateHeaderFavourites from 'lib/bridge/update-header-favourites'
import { updateHeaderFavouritesCount } from 'lib/actions/props'

import courseLogic from '~/scenes/course/show/logic'

import controller from '../controller.rb'

export default kea({
  initScene: {
    scene: 'courseShow',

    transform: payload => ({
      isInWishlist: payload.course.isInWishlist
    })
  },

  connect: {
    props: [courseLogic, ['course']]
  },

  path: () => ['scenes', 'courseShow', 'profileHeader', 'favouriteButton'],

  actions: () => ({
    toggleWishlistStatus: true,
    setIsInWishlist: true,
    setIsNotInWishlist: true
  }),

  reducers: ({ actions }) => ({
    isInWishlist: [
      false,
      PropTypes.bool,
      {
        [actions.setIsInWishlist]: () => true,
        [actions.setIsNotInWishlist]: () => false
      }
    ],
    isToggling: [
      false,
      PropTypes.bool,
      {
        [actions.toggleWishlistStatus]: () => true,
        [actions.setIsInWishlist]: () => false,
        [actions.setIsNotInWishlist]: () => false
      }
    ]
  }),

  takeLatest: ({ actions, workers }) => ({
    [actions.toggleWishlistStatus]: workers.toggleWishlistStatus
  }),

  workers: {
    * toggleWishlistStatus () {
      const { setIsInWishlist, setIsNotInWishlist } = this.actions

      const { id } = yield courseLogic.get('course')
      const isInWishlist = yield this.get('isInWishlist')

      let response
      if (isInWishlist) {
        response = yield controller.removeFavourite({ id })
      } else {
        response = yield controller.addFavourite({ id })
      }

      if (response.redirect_to_signup) {
        yield put(setIsNotInWishlist())
        window.location.href = response.redirect_path
        return
      }

      if (response.in_list) {
        yield put(setIsInWishlist())
      } else {
        yield put(setIsNotInWishlist())
      }

      updateHeaderFavourites(response.favourite_count) // old
      yield put(updateHeaderFavouritesCount(response.favourite_count)) // new
    }
  }
})
